<template>
  <div class="search-input">
    <label>
      <span class="label">{{ label }}:</span>
      <input type="text" v-model="searchQuery" v-on:keydown.enter="fetchGeoData" ref="textInput" />
    </label>
    <span v-if="multipleResults" class="tooltip">Meerdere resultaten gevonden / Multiple results found.</span>
  </div>
</template>

<script>
export default {
  name: "GeoSearchInput",
  props: {
    label: String,
  },
  data() {
    return {
      searchQuery: "",
      multipleResults: false,
      controls: this.$bluemap.mapViewer.controlsManager.data,
    };
  },
  methods: {
    async fetchGeoData() {
      let query = this.searchQuery.trim();
      if (query.length === 0) return;

      try {
        const response = await fetch(`https://geocraft.nl/geoservice/?key=${import.meta.env.VITE_GEOSERVICE}&action=search&q=${encodeURIComponent(query)}`);
        const data = await response.json();
        if (!Array.isArray(data.results) || data.results.length === 0) {
          this.multipleResults = false;
          this.$refs.textInput.style.borderColor = "red";
          return;
        }

        this.multipleResults = data.results.length > 1;
        this.$refs.textInput.style.borderColor = this.multipleResults ? "orange" : "initial";
        this.calculateCoordinates(data.results[0].latitude, data.results[0].longitude);
      } catch (e) {
        console.error("GeoSearchInput failed:", e);
        this.multipleResults = false;
        this.$refs.textInput.style.borderColor = "red";
      }
    },
    calculateCoordinates(latitude, longitude) {
      let dF = 0.36 * (latitude - 52.1551744);
      let dL = 0.36 * (longitude - 5.38720621);

      let SomX =
        190094.945 * dL +
        -11832.228 * dF * dL +
        -144.221 * Math.pow(dF, 2) * dL +
        -32.391 * Math.pow(dL, 3) +
        -0.705 * dF +
        -2.34 * Math.pow(dF, 3) * dL +
        -0.608 * dF * Math.pow(dL, 3) +
        -0.008 * Math.pow(dL, 2) +
        0.148 * Math.pow(dF, 2) * Math.pow(dL, 3);

      let SomY =
        309056.544 * dF +
        3638.893 * Math.pow(dL, 2) +
        73.077 * Math.pow(dF, 2) +
        -157.984 * dF * Math.pow(dL, 2) +
        59.788 * Math.pow(dF, 3) +
        0.433 * dL +
        -6.439 * Math.pow(dF, 2) * Math.pow(dL, 2) +
        -0.032 * dF * dL +
        0.092 * Math.pow(dL, 4) +
        -0.054 * dF * Math.pow(dL, 4);

      let x = 155000 + SomX;
      let z = 463000 + SomY;

      this.controls.position.x = x;
      this.controls.position.z = -z;
    },
  },
};
</script>

<style scoped>
.search-input {
  pointer-events: auto;
  background-color: var(--theme-bg);
  color: var(--theme-fg);
  min-height: 2em;
  position: relative;
  width: 20%;

  .label {
    display: inline-block;
    width: fit-content;
    padding: 0 0.5em 0 0.5em;
    color: var(--theme-fg-light);
  }

  input {
    height: 100%;
    line-height: 100%;
    width: calc(100% - 5em);
    background-color: inherit;
    color: inherit;
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .tooltip {
    border: solid 1px var(--theme-bg-light);
    padding: 8px;
    width: 90%;
    width: -webkit-fill-available;
    background-color: var(--theme-bg);
    color: red;
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>
